import { Pipe, PipeTransform } from '@angular/core';

import { SlimDocument } from '@app/models';
import { DocumentService } from '@app/services';

@Pipe({
  name: 'filterPendingSigners',
  standalone: false
})
export class FilterPendingSignersPipe implements PipeTransform {
  constructor(private documentService: DocumentService) {}

  transform(options: { signers: SlimDocument['signatures'] }): SlimDocument['signatures'] {
    return options.signers.filter(signer => signer.action && this.documentService.isSignerPending(signer));
  }
}
